module.exports = __webpack_public_path__ + "static/media/arrow-left-slider.dbf78f52.svg";